import * as React from 'react';
import { Activity, Message } from 'botframework-directlinejs';
import { ChatState, FormatState, SizeState, HistoryState } from './Store';
import { connect } from 'react-redux';
import { ActivityView } from './ActivityView';
import { konsole, classList, doCardAction, sendMessage } from './Chat';
import { getStyleValue, getNumberLines, isSmartPhoneMediaQuery, containsClass, addClass, removeClass, getPointBezierCurve, easings } from './utilites';
import { BigNumber } from 'bignumber.js';

export interface HistoryProps {
    format: FormatState,
    size: SizeState,
    history: HistoryState,
    activities: Activity[],
    candidates: string[],

    setMeasurements: (carouselMargin: number) => void,
    onClickRetry: (activity: Activity) => void,

    setFocus: () => void,
    store: any,
    options: any,

    isFromMe: (activity: Activity) => boolean,
    isSelected: (activity: Activity) => boolean,
    onClickActivity: (activity: Activity) => React.MouseEventHandler<HTMLDivElement>,
    doCardAction: (type: string, value: string, clientData:any) => void,
    sendMessage: (inputText: string, channelData:any) => void,
    changeHelpPopupHide? : (value :boolean) => void
}

export class HistoryView extends React.Component<HistoryProps, {}> {
    private scrollMe: HTMLDivElement;
    private autoPosMe: any;
    private scrollContent: HTMLDivElement;
    private scrollToBottom = true;

    private carouselActivity: WrappedActivity;
    private largeWidth: number;
    private chatAreaSpace = 0;

    public isThinking = false;
    public isMaintenance = false;
    public startFlg = false;

    private dataProps:HistoryProps;
    public optionState = {
        thinkingFlg    : true,
        maintenanceFlg : false,
        helloFlg       : false,
        queryStartFlg  : false
    };
    public oldActivities:Activity[];

    constructor(props: HistoryProps) {
        super(props);

        this.dataProps = this.props;
    }

    shouldComponentUpdate(nextProps: HistoryProps) {
        if (this.dataProps !== nextProps) {
           //this.dataProps.activities = nextProps.activities;
           this.oldActivities = this.dataProps.activities;
        }
        return true;
    }

    componentWillUpdate(nextProps: HistoryProps) {
        const oldThinkingFlg = this.optionState.thinkingFlg;

        // フック関数の実行
        if (this.props.options.beforeHistory &&
            typeof this.props.options.beforeHistory === "function") {
            const returnData = this.props.options.beforeHistory(this, nextProps);
            this.dataProps = returnData.props;
            this.optionState = returnData.state;
            nextProps = returnData.nextProps;
        }

        konsole.log("history:componentWillUpdate:helloFlg",this.optionState.helloFlg);

        this.scrollToBottom = (Math.abs(this.scrollMe.scrollHeight - this.scrollMe.scrollTop - this.scrollMe.offsetHeight) <= 1);

        // 考え中の時にスクロールすると後にBOTからの返答で吹き出しが更新されてもスクロールされない対策
        if (!this.scrollToBottom && oldThinkingFlg && !this.optionState.thinkingFlg) {
            this.scrollToBottom = true;
        }

        // 質問が開始されたらフラグを立てる
        if (this.props.store.getState().history.clientActivityCounter > 0 && !this.startFlg) this.startFlg = true;

    }

    componentDidUpdate() {
        if (this.props.format.carouselMargin == undefined) {
            // After our initial render we need to measure the carousel width

            // Measure the message padding by subtracting the known large width
            const paddedWidth = measurePaddedWidth(this.carouselActivity.messageDiv) - this.largeWidth;

            // Subtract the padding from the offsetParent's width to get the width of the content
            const maxContentWidth = (this.carouselActivity.messageDiv.offsetParent as HTMLElement).offsetWidth - paddedWidth;

            // Subtract the content width from the chat width to get the margin.
            // Next time we need to get the content width (on a resize) we can use this margin to get the maximum content width
            const carouselMargin = this.props.size.width - maxContentWidth;

            konsole.log('history measureMessage ' + carouselMargin);

            // Finally, save it away in the Store, which will force another re-render
            this.props.setMeasurements(carouselMargin)

            this.carouselActivity = null; // After the re-render this activity doesn't exist
        }

        this.autoPosition();
        this.autoscroll();
        this.resetQueryStartFlag();

        // フック関数の実行
        if (this.props.options.afterHistory &&
            typeof this.props.options.afterHistory === "function") {
            const returnData = this.props.options.afterHistory(this);
            this.dataProps = returnData.props;
            this.optionState = returnData.state;
        }
    }

    /**
     * 吹き出しエリアのスクロール
     */
    private autoscroll() {
        // 吹き出しの位置を下基準にする ※ 無効化
        //const vAlignBottomPadding = Math.max(0, measurePaddedHeight(this.scrollMe) - this.scrollContent.offsetHeight);
        //this.scrollContent.style.marginTop = vAlignBottomPadding + 'px';

        // スクロールを一番下に移動 ※ 無効化
        // if (this.scrollToBottom) this.scrollMe.scrollTop = this.scrollMe.scrollHeight - this.scrollMe.offsetHeight;

        if (!this.startFlg || !this.autoPosMe || !this.scrollMe) return;

        let marginTop = 7;
        const paddingTop = 18;
        let posTop = 0;
        const elem = this.autoPosMe.messageDiv;
        const _self = this;

        if (!elem) return;

        let targetElem = null;

        if (containsClass(elem, "wc-message-from-me")) {
            marginTop = 10;
            targetElem = elem.parentNode;

            let prevElem = targetElem.previousElementSibling;
            while (prevElem && containsClass(prevElem.childNodes[0], "wc-message-from-me")) {
                targetElem = prevElem;
                prevElem = prevElem.previousElementSibling;
            }
        }

        if (!targetElem) return;

        posTop = targetElem.offsetTop - paddingTop;
        posTop = posTop > 0 ? posTop + marginTop : posTop;

        if (!this.isPopupAnimate()) {
            if (!this.optionState.queryStartFlg) {
                _self.scrollMe.scrollTop = posTop;
            }
            return;
        }

        // スムーススクロール
        if (containsClass(elem, "wc-message-from-me") &&
            !containsClass(elem.parentNode, "scrolling") &&
            !containsClass(elem.parentNode, "animate") &&
            !containsClass(elem.parentNode, "animated")) {
            addClass(elem.parentNode, "scrolling");

            const duration = 400; // 移動時間

            const startPosTop = _self.scrollMe.scrollTop;
            const scrollDistance = posTop - startPosTop; // スクロール距離
            const startTime = new Date().getTime();
            const endTime = startTime + duration;

            let sid:any;

            // スクロール
            const scrollAnimation = () => {
                let elapsedTime = new Date().getTime() - startTime;
                let rate = Number(new BigNumber(elapsedTime).dividedBy(duration).toPrecision());
                let distance = Number(new BigNumber(rate).times(scrollDistance).toPrecision());

                if (elapsedTime < duration) {
                    _self.scrollMe.scrollTop = startPosTop + distance;
                    if (window.requestAnimationFrame) {
                        window.requestAnimationFrame(scrollAnimation);
                    }
                } else {
                    if (!window.requestAnimationFrame) clearInterval(sid);
                    _self.scrollMe.scrollTop = posTop;
                    this.popupAnimation();
                }
            };

            if (window.requestAnimationFrame) {
                window.requestAnimationFrame(scrollAnimation);
            } else {
                sid = setInterval(scrollAnimation, 10);
            }
        }
    }

    /**
     * スクロールと吹き出し移動間の遅延
     */
    private popupAnimation() {
        const elem = this.autoPosMe.messageDiv;

        if (!elem) return;

        const chatViewElem = elem.parentNode.parentNode.parentNode.parentNode.parentNode;
        const consoleElem = chatViewElem.querySelector(".wc-console");
        const consoleInputElem = chatViewElem.querySelector(".wc-console input");

        // スクロールバーの幅取得
        const hScrollWidth = elem.parentNode.parentNode.parentNode.offsetWidth - elem.parentNode.parentNode.offsetWidth;

        let spaceLeft = Number(getStyleValue(consoleElem, "padding-left").replace("px", ""));
        spaceLeft += Number(getStyleValue(consoleInputElem, "border-left").split(" ")[0].replace("px", ""));
        spaceLeft += Number(getStyleValue(consoleInputElem, "padding-left").replace("px", ""));

        let startX = elem.clientWidth - elem.querySelector(".chat-main").clientWidth - spaceLeft;
        let startY = this.scrollMe.clientHeight;

        let duration = 700; // 移動時間
        const delay = 200; // スクロール終了後の間隔

        if (typeof this.props.options.popupAnimate !== "undefined" &&
            typeof this.props.options.popupAnimate.duration !== "undefined") {
            duration = this.props.options.popupAnimate.duration;
        }

        let speed = (startY / duration) * 10;
        let elapsedTime = 0;

        const ctrlPointX = startX / 12;
        const ctrlPointY = startY - (startY / 12);

        /**
         * アニメーションの開始
         */
        const animate = () => {
            elapsedTime = Number(new BigNumber(elapsedTime).plus(speed).toPrecision());

            let timeRate = Number(new BigNumber(elapsedTime).dividedBy(duration).toPrecision());

            timeRate = easings.easeOutQuint(timeRate);

            const point = getPointBezierCurve(
                timeRate > 1 ? 1 : timeRate,
                startX,
                startY,
                ctrlPointX,
                ctrlPointY,
                0,
                startY - ctrlPointY,
                0,
                0
            );

            if (point.x < 0) point.x = 0;
            if (point.y < 0) point.y = 0;

            setPosition(point.x, point.y);

            if (point.x === 0 && point.y === 0) {
                animatePopupElem.parentNode.removeChild(animatePopupElem);

                // 少し遅延
                addClass(elem.parentNode, "animated");
                setTimeout(() => {
                    removeClass(elem.parentNode, "animate");
                }, 200);
            } else {
                setTimeout(animate, speed);
            }
        };

        /**
         * アニメーション用吹き出しの位置をセット
         * @param x 設定するX軸の位置
         * @param y 設定するY軸の位置
         */
        const setPosition = (x:number, y:number) => {
            const xPos = x === 0 ? 0 : "-" + x + "px";
            const yPos = y === 0 ? 0 : y + "px";

            const transformVal = "translate(" + xPos + ", " + yPos + ")";

            animatePopupElem.style.webkitTransform = transformVal;
            (animatePopupElem.style as any).msTransform = transformVal;
            animatePopupElem.style.transform = transformVal;
        }

        const cloneHTML = elem.parentNode.innerHTML;
        let  animatePopupElem = document.createElement("div");
        animatePopupElem.innerHTML = cloneHTML;
        animatePopupElem.className = "wc-message-wrapper list animate-message hide";

        setPosition(startX, startY);

        animatePopupElem = chatViewElem.appendChild(animatePopupElem);

        // スクロール終了後の間隔を少し空ける
        setTimeout(() => {
            removeClass(animatePopupElem, "hide");
            addClass(elem.parentNode, "animate");
            removeClass(elem.parentNode, "scrolling");

            if (!isSmartPhoneMediaQuery.matches) {
                animatePopupElem.style.right = (hScrollWidth + 1) + "px";
            }

            setTimeout(animate, speed);
        }, delay);
    }

    /**
     * 吹き出しの位置を上にそろえる
     */
    private autoPosition() {
        if (!this.autoPosMe || !this.scrollMe) {
            if (this.scrollMe) (this.scrollMe.childNodes[0] as HTMLElement).style.paddingBottom = "";
            return;
        }

        const paddingTop = isSmartPhoneMediaQuery.matches ? 17 : 18;
        const paddingBottom = isSmartPhoneMediaQuery.matches ? 20 : 27;
        const viewAreaHeight = this.scrollMe.clientHeight;
        const elem = this.autoPosMe.messageDiv;
        const innerElem = this.scrollMe.childNodes[0] as HTMLElement;

        if (!elem) {
            innerElem.style.paddingBottom = "";
            this.chatAreaSpace = 0;
            return;
        }

        const parentElem = elem.parentNode;
        let totalHeight = parentElem.offsetHeight;

        if (containsClass(elem, "wc-message-from-bot")) {
            let targetElem = parentElem;
            let prevElem = targetElem.previousElementSibling;
            while (prevElem && containsClass(prevElem.childNodes[0], "wc-message-from-bot")) {
                totalHeight += prevElem.offsetHeight;
                targetElem = prevElem;
                prevElem = prevElem.previousElementSibling;
            }
        }

        let setPaddingBottom = viewAreaHeight - (totalHeight + paddingTop + paddingBottom);

        if (totalHeight && totalHeight < viewAreaHeight) {
            innerElem.style.paddingBottom = setPaddingBottom + "px";
            this.chatAreaSpace = setPaddingBottom;
        } else {
            innerElem.style.paddingBottom = "";
            this.chatAreaSpace = 0;
        }
    }

    /**
     * 吹き出しアニメーションを行うかどうか
     */
    private isPopupAnimate() {
        if (this.props.options.popupAnimate) {
            if (this.optionState.queryStartFlg) return false;

            if (typeof this.props.options.popupAnimate.enable === "boolean") {
                return this.props.options.popupAnimate.enable;
            } else if (typeof this.props.options.popupAnimate === "boolean") {
                return this.props.options.popupAnimate;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    /**
     * 吹き出しアニメーションの一時停止をリセット
     */
    private resetQueryStartFlag() {
        if (!this.optionState.queryStartFlg) return;
        if (!this.startFlg || !this.autoPosMe || !this.scrollMe) return;
        const elem = this.autoPosMe.messageDiv;
        if (!elem) return;
        if (containsClass(elem, "wc-message-from-bot")) {
            let prevElem = elem.parentNode.previousElementSibling;
            if (prevElem && containsClass(prevElem.childNodes[0], "wc-message-from-me")) {
                this.optionState.queryStartFlg = false;
            }
        }
    }

    // In order to do their cool horizontal scrolling thing, Carousels need to know how wide they can be.
    // So, at startup, we create this mock Carousel activity and measure it.
    private measurableCarousel = () =>
        // find the largest possible message size by forcing a width larger than the chat itself
        <WrappedActivity
            ref={ (x:any) => this.carouselActivity = x }
            activity={ {
                type: 'message',
                id: '',
                from: { id: '' },
                attachmentLayout: 'carousel'
            } }
            format={ null }
            fromMe={ false }
            onClickActivity={ null }
            onClickRetry={ null }
            selected={ false }
            showTimestamp={ false }
            options={ this.props.options }
            onCardAction={ (type: string, value: string) => { return this.doCardAction(type, value)} }
            sendMessage={this.props.sendMessage}
        >
            <div style={ { width: this.largeWidth } }>&nbsp;</div>
        </WrappedActivity>;

    // At startup we do three render passes:
    // 1. To determine the dimensions of the chat panel (not much needs to actually render here)
    // 2. To determine the margins of any given carousel (we just render one mock activity so that we can measure it)
    // 3. (this is also the normal re-render case) To render without the mock activity

    private doCardAction(type: string, value: string) {
        var clientData:any = null;
        if (type === "imBack") {
            this.props.changeHelpPopupHide(true);
            // クライアントデータの取得
            let data = {
                inputText : value,
                clientData: clientData,
                cardActionType: type
            };
            if (this.props.options.beforeAsking &&
                typeof this.props.options.beforeAsking === "function") {
                const returnData = this.props.options.beforeAsking({}, data);
                clientData = returnData.data.clientData;
                // 7/17 OSK KURI 手入力のbeforeAskingとの互換のため入力値を
                // 　　　　　　　　設定して関数を呼び出すが、imBackは指定された
                // 　　　　　　　　パラメータを戻す仕様であるため変換された入力値
                // 　　　　　　　　は利用しない。
                // value = returnData.data.inputText;
            }
        } else {
            this.props.setFocus();
        }
        return this.props.doCardAction(type, value, clientData);
    }

    render() {
        konsole.log("History props", this);
        let content;

        const state = this.props.history;
        const is_maintenance = (state != null) && state.isMaintenance
            ? true
            : false
            ;

        if (this.props.size.width !== undefined) {
            if (this.props.format.carouselMargin === undefined) {
                // For measuring carousels we need a width known to be larger than the chat itself
                this.largeWidth = this.props.size.width * 2;
                content = <this.measurableCarousel/>;
            } else {
                content = this.props.activities.map((activity, index) => {
                    if (this.props.options.maintenance && !this.props.isFromMe(activity)) return '';
                    return <WrappedActivity
                        format={ this.props.format }
                        key={ "message" + index }
                        activity={ activity }
                        showTimestamp={ index === this.props.activities.length - 1 || (index + 1 < this.props.activities.length && suitableInterval(activity, this.props.activities[index + 1])) }
                        selected={ this.props.isSelected(activity) }
                        fromMe={ this.props.isFromMe(activity) }
                        onClickActivity={ this.props.onClickActivity(activity) }
                        onClickRetry={ (e:any) => {
                            // Since this is a click on an anchor, we need to stop it
                            // from trying to actually follow a (nonexistant) link
                            e.preventDefault();
                            e.stopPropagation();
                            this.props.onClickRetry(activity)
                        } }
                        options={ this.props.options }
                        ref={ (div:any) => this.autoPosMe = div || this.autoPosMe }
                        onCardAction={ (type: string, value: string) => { return this.doCardAction(type, value)} }
                        sendMessage={ this.props.sendMessage }
                        runScroll={() => {
                            this.autoPosition();
                            this.autoscroll();
                            this.resetQueryStartFlag();
                        }}
                    >
                        <ActivityView
                            format={ this.props.format }
                            size={ this.props.size }
                            activity={ activity }
                            candidates={ this.props.candidates }
                            onCardAction={ (type: string, value: string) => { return this.doCardAction(type, value)} }
                            sendMessage={ (inputText: string, channelData:any) => { return this.props.sendMessage(inputText, channelData)} }
                            onImageLoad={ () => this.autoscroll() }
                            options={ this.props.options }
                            store= { this.props.store }
                        />
                    </WrappedActivity>
                });
            }
        }

        return (
            <div className="wc-message-groups" ref={ (div:any) => this.scrollMe = div || this.scrollMe }>
                <div className="wc-message-group-content" ref={ (div:any) => this.scrollContent = div }>
                    { content }
                    <ThinkingActivity isThinking={ this.optionState.thinkingFlg } ></ThinkingActivity>
                    <MaintenanceActivity isMaintenance={ this.optionState.maintenanceFlg || is_maintenance } ></MaintenanceActivity>
                    <HeightSpaceActivity/>
                </div>
            </div>
        );
    }
}

export const History = connect(
    (state: ChatState) => ({
        // passed down to HistoryView
        format: state.format,
        size: state.size,
        history: state.history,
        activities: state.history.activities,
        candidates: state.shell.candidates,
        // only used to create helper functions below
        connectionSelectedActivity: state.connection.selectedActivity,
        selectedActivity: state.history.selectedActivity,
        botConnection: state.connection.botConnection,
        user: state.connection.user
    }), {
        setMeasurements: (carouselMargin: number) => ({ type: 'Set_Measurements', carouselMargin }),
        onClickRetry: (activity: Activity) => ({ type: 'Send_Message_Retry', clientActivityId: activity.channelData.clientActivityId }),
        // only used to create helper functions below
        sendMessage
    }, (stateProps: any, dispatchProps: any, ownProps: any): HistoryProps => ({
        // from stateProps
        format: stateProps.format,
        size: stateProps.size,
        history: stateProps.history,
        activities: stateProps.activities,
        candidates: stateProps.candidates,
        // from dispatchProps
        setMeasurements: dispatchProps.setMeasurements,
        onClickRetry: dispatchProps.onClickRetry,
        // from ownProps
        setFocus: ownProps.setFocus,
        store: ownProps.store,
        options: ownProps.options,
        changeHelpPopupHide: ownProps.changeHelpPopupHide,
        // helper functions
        doCardAction: doCardAction(stateProps.botConnection, stateProps.user, stateProps.format.locale, dispatchProps.sendMessage),
        sendMessage: (text: string, channelData:any) => {
            dispatchProps.sendMessage(text, stateProps.user, stateProps.format.locale, channelData);
        },
        isFromMe: (activity: Activity) => activity.from.id === stateProps.user.id,
        isSelected: (activity: Activity) => activity === stateProps.selectedActivity,
        onClickActivity: (activity: Activity) => stateProps.connectionSelectedActivity && (() => stateProps.connectionSelectedActivity.next({ activity }))
    })
)(HistoryView);

const getComputedStyleValues = (el: HTMLElement, stylePropertyNames: string[]) => {
    const s = window.getComputedStyle(el);
    const result: { [key: string]: number } = {};
    stylePropertyNames.forEach((name:any) => result[name] = parseInt(s.getPropertyValue(name)));
    return result;
}

const measurePaddedHeight = (el: HTMLElement): number => {
    const paddingTop = 'padding-top', paddingBottom = 'padding-bottom';
    const values = getComputedStyleValues(el, [paddingTop, paddingBottom]);
    return el.offsetHeight - values[paddingTop] - values[paddingBottom];
}

const measurePaddedWidth = (el: HTMLElement): number => {
    const paddingLeft = 'padding-left', paddingRight = 'padding-right';
    const values = getComputedStyleValues(el, [paddingLeft, paddingRight]);
    return el.offsetWidth + values[paddingLeft] + values[paddingRight];
}

const suitableInterval = (current: Activity, next: Activity) =>
    Date.parse(next.timestamp) - Date.parse(current.timestamp) > 5 * 60 * 1000;

export interface WrappedActivityProps {
    activity: Activity,
    showTimestamp: boolean,
    selected: boolean,
    fromMe: boolean,
    format: FormatState,
    onClickActivity: React.MouseEventHandler<HTMLDivElement>,
    onClickRetry: React.MouseEventHandler<HTMLAnchorElement>,
    options: any,
    onCardAction: (type: string, value: string) => void,
    sendMessage: (inputText: string, channelData:any) => void,
    runScroll?:() => void
}

export interface WrappedActivityState {
    remarkVisible: boolean;
 }

export class WrappedActivity extends React.Component<WrappedActivityProps, WrappedActivityState> {
    public messageDiv: HTMLDivElement;
    private oneLineOnly: boolean = false;

    constructor(props: WrappedActivityProps) {
        super(props);
        this.state = {
            remarkVisible: false //解除発言　初期不可視
        };
    }

    // 振り分け解除命令送信
    sendInvalidation = () => {
        let childBotNameObj = ((this.props.activity as Message).entities || []).find((x) => x.childBotName);

        //解除命令の送信
        let channelData =
            {
                clientData: {
                    cmd:
                    {
                        "cmd": "returnParrentAssistant",
                        "key": ((this.props.activity as Message).entities || []).find((x) => x.childBot).childBot,
                        "value": 1
                    }
                }
            }
        let message = `「${childBotNameObj.childBotName}」ではない質問がしたい`;
        this.props.sendMessage(message, channelData);
    }

    render () {
        let timeLine: JSX.Element;
        switch (this.props.activity.id) {
            case undefined:
                timeLine = <span>{ this.props.format.strings.messageSending }</span>;
                break;
            case null:
                timeLine = <span>{ this.props.format.strings.messageFailed }</span>;
                break;
            case "retry":
                timeLine =
                    <span>
                        { this.props.format.strings.messageFailed }
                        { ' ' }
                        <a href="." onClick={ this.props.onClickRetry }>{ this.props.format.strings.messageRetry }</a>
                    </span>;
                break;
            default:
                let sent: string;
                if (this.props.showTimestamp)
                    sent = this.props.format.strings.timeSent.replace("%1", (new Date(this.props.activity.timestamp)).toLocaleTimeString());
                timeLine = <span>{ this.props.activity.from.name || this.props.activity.from.id }{ sent }</span>;
                break;
        }

        const who = this.props.fromMe ? "me" : "bot";

        const wrapperClassName = classList(
            "wc-message-wrapper",
            (this.props.activity as Message).attachmentLayout || "list",
            this.props.onClickActivity && 'clickable'
        );

        const contentClassName = classList(
            "wc-message-content",
            this.props.selected && "selected"
        );

        // アバターの切り替え
        let entities = (this.props.activity as Message).entities || [];
        const iconEntity= entities.find((v:any) => v.icon);
        const iconName = iconEntity ? 'emo-' + iconEntity.icon : null;

        const cnvCategoryEntiry = entities.find((v:any) => v.cnv_category);
        const cnvCategory = cnvCategoryEntiry ? "cat-" + cnvCategoryEntiry.cnv_category : null;

        const iconClass = [iconName, cnvCategory].join(' ');

        // 吹き出しの1行処理
        let statementClassName = "chat-statement";
        if (this.messageDiv) {
            const chatMainElem = this.messageDiv.querySelector(".chat-main");
            const line = getNumberLines(chatMainElem);
            if (line === 1) statementClassName += " one-line-only";
        }

        //子チャットボット名取得
        var childBotNameObj = entities.find((v:any) => v.childBotName);

        return (
            <div data-activity-id={ this.props.activity.id } className={ wrapperClassName } onClick={ this.props.onClickActivity }>
                {this.props.options.integrationMode ?
                <div className={ "wc-message-from wc-message-from-" + who }>
                    <span className="accompanying-info">
                        <span className="answerer">パソコンくん</span>
                        {childBotNameObj ?
                        <button type="button" onClick={ this.sendInvalidation } disabled={ this.state.remarkVisible }>
                            { childBotNameObj.childBotName }
                        </button>
                        : null }
                    </span>
                </div>
                : null }
                <div className={ "wc-message wc-message-from-" + who } ref={ (div:any) => this.messageDiv = div }>
                    <div className={ contentClassName }>
                        <div className={ "osk-icon " + iconClass }></div>

                        <div className={ statementClassName }>
                            <div className="chat-statement-inner">
                                { this.props.children }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

/**
 * 考え中の吹き出し
 */
export interface ThinkingActivityProps {
    isThinking: any
}

export class ThinkingActivity extends React.Component<ThinkingActivityProps, {}> {

    constructor(props: ThinkingActivityProps) {
        super(props);
    }

    render() {
        return (
            <div className={`wc-message-wrapper list waiting ${this.props.isThinking ? "" : "hide"}`}>
                <div className="wc-message wc-message-from-bot">
                    <div className="wc-message-content">
                        <div className="osk-icon"></div>
                        <div className="chat-statement one-line-only">
                            <div className="chat-statement-inner">
                                <div className="chat-main"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="wc-message-from wc-message-from-bot"></div>
            </div>
        );
    }
}

/**
 * メンテナンスの吹き出し
 */
export interface MaintenanceActivityProps {
    isMaintenance: any
}

export class MaintenanceActivity extends React.Component<MaintenanceActivityProps, {}> {

    constructor(props: MaintenanceActivityProps) {
        super(props);
    }

    render () {
        return (
            <div className={`wc-message-wrapper list maintenance ${this.props.isMaintenance ? "" : "hide"}`}>
                <div className="wc-message wc-message-from-bot">
                    <div className="wc-message-content">
                        <div className="osk-icon"></div>
                        <div className="chat-statement">
                            <div className="chat-statement-inner">
                                <div className="chat-main">大変申し訳ございません。ただいまチャットボットのメンテナンスをしております。<br/>再開までしばらくお待ちください。</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="wc-message-from wc-message-from-bot"></div>
            </div>
        );
    }
}

/**
 * 表示領域の余白確保
 */
export interface HeightSpaceActivityProps {}

export class HeightSpaceActivity extends React.Component<HeightSpaceActivityProps, {}> {

    constructor(props: HeightSpaceActivityProps) {
        super(props);
    }

    render () {
        return (
            <div className={`space`}></div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/History.tsx